import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {ErrorHandlingService} from './error-handling.service';
import {catchError} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({
        providedIn: 'root'
})
export class ChatBotService {
  private readonly errorHandler = inject(ErrorHandlingService);
  private readonly http = inject(HttpClient);

  public sendMessage(message: string):  Observable<{ answer: string }>{
    return this.http.post('/chat/message', {message})
      .pipe(
        catchError((err) => this.errorHandler.handleError(err))
      );
  }
}
